import React, { FC, Fragment } from 'react'
import styled from '@emotion/styled'
import { useNavigate } from 'react-router-dom'

export interface HandleBtnOptions {
    icon: string
    link: string
}

export const HandleBtns: FC<{ buttons: HandleBtnOptions[] }> = ({ buttons }) => {
    const navigate = useNavigate()

    return (
        <>
            {!!buttons.length && (
                <ListWrapper>
                    {buttons.map((btn, index) => (
                        <Fragment key={index}>
                            {!!index && <div className="space" />}
                            <div className="tag-item" onClick={() => btn.link && navigate(btn.link)}>
                                <img src={btn.icon} alt="" />
                            </div>
                        </Fragment>
                    ))}
                </ListWrapper>
            )}
        </>
    )
}

const ListWrapper = styled.div`
    display: flex;
    align-items: center;
    .space {
        width: 30px;
    }
    .tag-item {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .img {
            width: 100%;
            height: auto;
        }
    }
`
